module.exports = __webpack_public_path__ + "img/L_4D.c2022459.png";